import { Component, OnInit,DoCheck } from '@angular/core';
import {FormGroup, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import {Location} from '@angular/common';
import { ControlService } from 'src/app/services/control/control.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLoginService } from 'src/app/services/UserLogin/userLoginService';
import { EmailService } from 'src/app/services/email/emailService';

@Component({
  selector: 'app-edit-control',
  templateUrl: './edit-control.component.html',
  styleUrls: ['./edit-control.component.css']
})
export class EditControlComponent implements OnInit,DoCheck {

  public editControlForm:FormGroup;
  public createControlProduct:any=[];
  public myMonth="";
  public myId:any;
  discriminador: boolean=false;

  constructor(
    private location:Location,
    private controlService:ControlService,
    private messageService:MessageService,
    private route:ActivatedRoute,
    private usuarioLoginName:UserLoginService,
    private router:Router,
    private emailService:EmailService
    ){
      this.empezar();
  
  }
  empezar(){
    this.iniciar(null);
    this.route.params.subscribe(data=>{
      
     this.myId=data.id;
      this.controlService.getIdControl(this.myId).subscribe(resp=>{
       
        this.iniciar(resp[0]);
      })
    });
  }
  
  ngOnInit(): void {
 
}

  ngDoCheck(){
   this.cambiarMes();
   
  }
  comprobar(){
  
    if(this.discriminador){
     
      this.editControlForm.patchValue({
        zona1:false,
        zona2:false,
        zona3:false,
        zona4:false,
        zona5:false,
        zona6:false,
        zona7:false,
        zona8:false,
        zona9:false,
      });
      this.discriminador=false;
    }else{
      this.editControlForm.patchValue({
        zona1:true,
        zona2:true,
        zona3:true,
        zona4:true,
        zona5:true,
        zona6:true,
        zona7:true,
        zona8:true,
        zona9:true,
      });
      this.discriminador=true;
    }
  }

  iniciar(control:any){
  if(control==null){
    this.editControlForm=new FormGroup({
      id:new FormControl(''),
      fecha:new FormControl('',Validators.required),
      mes:new FormControl(''),
      zona1:new FormControl(true),
      zona2:new FormControl(true),
      zona3:new FormControl(true),
      zona4:new FormControl(true),
      zona5:new FormControl(true),
      zona6:new FormControl(true),
      zona7:new FormControl(true),
      zona8:new FormControl(true),
      zona9:new FormControl(true),
      fechaoperario:new FormControl(''),
      nombreoperario:new FormControl(''),
      revisado_fecha:new FormControl(''),
      revisado_nombre:new FormControl(''),
      observaciones:new FormControl('')
    });
  }else{
    this.editControlForm=new FormGroup({
      id:new FormControl(this.myId),
      fecha:new FormControl(control.fecha,Validators.required),
      mes:new FormControl(this.myMonth),
      zona1:new FormControl( control.zona1 ),
      zona2:new FormControl( control.zona2 ),
      zona3:new FormControl( control.zona3 ),
      zona4:new FormControl( control.zona4 ),
      zona5:new FormControl( control.zona5 ),
      zona6:new FormControl( control.zona6 ),
      zona7:new FormControl( control.zona7 ),
      zona8:new FormControl( control.zona8 ),
      zona9:new FormControl( control.zona9 ),
      fechaoperario:new FormControl( control.fechaoperario ),
      nombreoperario:new FormControl( control.nombreoperario ),
      revisado_fecha:new FormControl( control.revisado_fecha ),
      revisado_nombre:new FormControl( control.revisado_nombre ),
      observaciones:new FormControl( control.observaciones )
    });
  }
    
  }
  onSubmit(){
  
    this.controlService.updateControl(this.editControlForm.value).subscribe(resp=>{
     // console.log(this.editControlForm.value);
      this.messageService.add({severity:'success', summary:'Registro', detail:'Registro guardado correctamente'});
      //this.empezar();
      let observaciones: string = this.editControlForm.controls.observaciones.value;
      if(observaciones === null || observaciones === undefined || observaciones.length == 0 ){

      }else{
        this.emailService.sendMessage(this.editControlForm.value,'CONTROL DE CRISTALES, PLÁSTICOS, LUCES Y METALES').toPromise().then(data =>{
         // console.log('data', data);
        }).catch( error => {
          console.log('error message', error);
        });
      }
      setTimeout(function(){
        this.router.navigate(['dashboard/control']);
      }.bind(this),2000);
    },error=>{
      console.log("Error",error);
      this.messageService.add({severity:'error', summary:'Resgistro', detail:'Error en el registro '+error+''});
    

    });
  }
  cambiarMes(){
    let fecha=this.editControlForm.controls.fecha.value;
   
    let posiciones=fecha.split("-");
    this.myMonth=this.seleccionarMes(parseInt(posiciones[1]));
    
    this.editControlForm.patchValue({
      'mes':this.myMonth,
    });

  }
  seleccionarMes(mes){
   
    let month="";
      switch(mes) {
      case 1:
      month="Enero";
      break;
      case 2:
      month="Febrero";
      break;
      case 3:
      month="Marzo";
      break;
      case 4:
      month="Abril";
      break;
      case 5:
      month="Mayo";
      break;
      case 6:
      month="Junio";
      break;
      case 7:
      month="Julio";
      break;
      case 8:
      month="Agosto";
      break;
      case 9:
      month="Septiembre";
      break;
      case 10:
      month="Octubre";
      break;
      case 11:
      month="Noviembre";
      break;
      case 12:
      month="Diciembre";
      break;
      default:
     
  }
  return month;
  }
  fecha(){
    let today = new Date();
    let dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();
    
   
    let myfecha = mm + '/' + dd + '/' + yyyy;
   // myfecha=yyyy+'-'+mm + '-' + dd ;
  
    return myfecha;
   }

   
  regresar(){
    this.location.back();
  }

}
